// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueFeather from 'vue-feather';
Vue.use(VueFeather);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
import Datepicker from 'vue2-datepicker';
Vue.component('datepicker', Datepicker)
import Toasted from 'vue-toasted'
Vue.use(Toasted)

import vueCookies from 'vue-cookies'
Vue.use(vueCookies)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
//==============moment===========================
Vue.use(require('vue-moment'))
//================paginate=======================
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)
//==================Loader=========================
import Loader from './components/fxView/shared/loader'
Vue.component('loader', Loader);

import password_icon from './components/fxView/shared/password_icon'
Vue.component('PasswordIcon', password_icon);

import pagination from '@/components/fxView/shared/pagination'
Vue.component('app-pagination', pagination)



Vue.config.productionTip = false
window.$ = require('jquery')
window.JQuery = require('jquery')
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js